module.exports = __webpack_public_path__ + "img/视频选中.91198c7c.png";